/**
 * 保证传入 DataV / Canvas 的数值有限，避免 createLinearGradient 报 non-finite
 */
export function toFiniteNumber (value, fallback = 0) {
  const n = Number(value)
  return Number.isFinite(n) ? n : fallback
}

export function toFinitePercent (done, total) {
  const t = toFiniteNumber(total, 0)
  const d = toFiniteNumber(done, 0)
  if (t <= 0) return 0
  return Math.min(100, Math.max(0, Math.round((d / t) * 10000) / 100))
}

export function toFiniteSeries (arr) {
  if (!Array.isArray(arr)) return []
  return arr.map(v => toFiniteNumber(v, 0))
}

/**
 * 数值轴上限：空数据 / 全 0 时用 fallback，避免 DataV 刻度出现 NaN
 */
export function calcValueAxisMax (values, fallback = 10) {
  const list = Array.isArray(values) ? values : []
  const maxVal = list.length
    ? Math.max(0, ...list.map(v => toFiniteNumber(v, 0)))
    : 0
  if (maxVal <= 0) return fallback
  const step = maxVal <= 5 ? 1 : maxVal <= 20 ? 5 : 10
  return Math.ceil(maxVal / step) * step
}

/** 等待 DOM 有有效宽高后再初始化 DataV Charts，避免 grid.render.area 报错 */
export function waitForElementSize (el, { minWidth = 1, minHeight = 1, maxFrames = 90 } = {}) {
  return new Promise((resolve) => {
    if (!el) {
      resolve(false)
      return
    }
    let frames = 0
    const tick = () => {
      if (!el.isConnected) {
        resolve(false)
        return
      }
      const { clientWidth: w, clientHeight: h } = el
      if (w >= minWidth && h >= minHeight) {
        resolve(true)
        return
      }
      frames += 1
      if (frames >= maxFrames) {
        resolve(w > 0 && h > 0)
        return
      }
      requestAnimationFrame(tick)
    }
    requestAnimationFrame(tick)
  })
}
